import { makeUseAnalytics } from '@plato/app-core/hooks/make-use-analytics';

type AskPlatoAnalyticsEvents = {
    /**
     * Triggered when a starter question on the home-dashboard Ask Plato card is
     * picked. `visit_prep` opens the chat with the question pre-filled for the
     * customer name; the others send at once and show up as
     * `ai_chat_message_submitted` too.
     */
    ai_chat_starter_question_selected: {
        question: 'visit_prep' | 'revenue_decline' | 'revenue_vs_last_year';
    };
};

export const useAnalytics = makeUseAnalytics<AskPlatoAnalyticsEvents>();
